import { baseUrlV2, createQueryParameters, fetchOptionsV2, getCredentials } from './http';
import { FourOhOneError } from '../actionCreators/system';
import CustomToast from '../components/Redesing/custom-toast';
import { IHardware, IUseHardwareFilter } from '../ts/interface/hardware.interface';
import { API_PAGINATION_LIMIT } from '../constants';

/**
 * Response type for the V2 hardware API
 */
export interface HardwareV2Response {
  data: IHardware[];
  has_more: boolean;
}

export const getHardwareV2 = (
  parameters?: IUseHardwareFilter
): Promise<HardwareV2Response | null> => {
  const { adminEmail, adminToken, systemGid } = getCredentials();

  const system_id = parameters?.system_id || systemGid;

  const { search, ...restParameters } = parameters || {};

  const queryParametersObject = {
    limit: parameters?.limit || API_PAGINATION_LIMIT,
    ...(parameters?.organization_id
      ? { include_sub_organizations: true }
      : { system_id }),
    ...(search && {
      'search[columns]':
        "hardware.mac,hardware.label,hardware.config->>'location',hardware.config->>'firmware_version',hardware.config->>'latch_type',station.name,system.name",
      'search[term]': search,
    }),
    ...restParameters,
  };

  const queryParameters = createQueryParameters(queryParametersObject);
  const fetchOps = fetchOptionsV2(adminEmail, adminToken);
  //@ts-ignore
  return fetch(`${baseUrlV2}/hardware/?${queryParameters}`, fetchOps)
    .then((response) => response.json())
    .then((response) => {
      if (response.data) {
        return response;
      }
      FourOhOneError(response);
      throw new Error(response.message);
    })
    .catch((e) => {
      CustomToast({
        type: 'error',
        message: 'Error fetching hardware data. Please try again.',
      });
      return null;
    });
};
